import dayjs from "dayjs";
import React from "react";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import { getAllPaymentTracking } from "../../services/paymentTracking.service";
import { useError } from "../../store/ErrorModal";

export default function usePaymentCustomerPage() {
  const [payment, setPayment] = React.useState<IPaymentTracking[]>([]);
  const [dataForShow, setDataForShow] = React.useState<IPaymentTracking[]>([]);
  const [searchKey, setSearchKey] = React.useState<string>("");
  const [initialDate, setInitialDate] = React.useState<Date>(
    new Date("2021-09-25")
  );
  const [finaleDate, setFinaleDate] = React.useState<Date>(new Date());
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      const paymentData = await getAllPaymentTracking();
      setPayment(paymentData.data);
    } catch (error: any) {
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  React.useEffect(() => {
    if (!payment || payment.length === 0) return;
    const formatDate = (date: string | number | Date) =>
      new Date(dayjs(date).format("YYYY-MM-DD"));
    const dateData = payment.filter((item) => {
      if (
        formatDate(item.timeStamp) < formatDate(initialDate || new Date()) ||
        formatDate(item.timeStamp) > formatDate(finaleDate || new Date())
      )
        return false;
      return true;
    });
    const nData = dateData.filter((item) => {
      item.firstName = item.firstName || "";
      item.lastName = item.lastName || "";
      item.displayName = item.displayName || "";
      const status =
        +item.status === 0
          ? "ยังไม่ชำระเงิน"
          : +item.status === 1
          ? "ชำระเงินแล้ว"
          : +item.status === 2
          ? "กำลังให้บริการ"
          : "";
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        status.includes(searchKey)
      );
    });
    nData.sort(
      (a, b) =>
        new Date(b.timeStamp).getTime() - new Date(a.timeStamp).getTime()
    );

    setDataForShow(nData);
  }, [searchKey, setSearchKey, initialDate, finaleDate, payment]);

  const header = [
    "วันที่บันทึก",
    "ชื่อลูกค้า",
    "ข้อมูลสินค้า",
    "รายละเอียด",
    "สลิปจ่ายเงิน",
    "สถานะ",
  ];

  return {
    dataForShow,
    setInitialDate,
    setFinaleDate,
    isLoading,
    header,
    setSearchKey,
    fetchData,
  };
}
